import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

//根据admin管理员的已有的权限api获取route
export function getrouteByApi(routes, adminApi) {
  let res = []
  let childrenData = []
  for (let route of routes) {
    if(route.apis && route.apis.length){
      for(let i = 0; i<route.apis.length; i++){
        if(adminApi.includes(route.apis[i])){
          res.push(route)
        }
      }
    }
    //console.log(route.children);
   if (route.children) {
       childrenData = getrouteByApi(route.children, adminApi)
       if(childrenData.length){res = res.concat(childrenData)}
    }
  }
  return res
}

export function indexOf(arr,ele,index=[]){
  index = index.slice()
  for (let i = 0; i< arr.length; i++){
    if( ele === arr[i]){
      index.push(i)
      return index
    } else if (arr[i].children){
      index.push(i)
      let ret = indexOf(arr[i].children,ele,index)
      if (ret){
          return ret
      }
      index.pop()
    }
  }
}

function filterArr(Routes, ids){
    return Routes.reduce((list, item) => {
        let has = ids.includes(item.name)
        let res = {...item}
        if(!has && Array.isArray(item.children)){
            res.children = filterArr(item.children, ids)
            has = !!res.children.length
        }

        has && list.push(res)
        return list
    }, [])
}

//根据已有权限的index数组获取route的name
export function getPaths(Routes, indexarr){
  let newRoutes = []
  let names = []
  for(let i = 0; i< indexarr.length; i++){
    if(i == 0){
      names.push(Routes[indexarr[i]].name)
      if(i == indexarr.length-1) return names
    }else if(i > 0){
      let res = getPaths(Routes[indexarr[i-1]].children, indexarr.slice(1))
      newRoutes = newRoutes.concat(res)
      return newRoutes
    }
  }
}


const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, { roles, manage_power }) {
    return new Promise(resolve => {
      let accessedRoleRoutes = []
      let names = []
      let accessedRoutes
      if (roles.includes('super')) {
        accessedRoleRoutes = asyncRoutes || []
      } else {
        filterAsyncRoutes = filterAsyncRoutes(asyncRoutes, roles)
        accessedRoutes = getrouteByApi(filterAsyncRoutes, manage_power)//根据已有权限api获取route
        accessedRoutes = [...new Set(accessedRoutes)]//数组去重
        let indexarr
        for(let item of accessedRoutes){
          indexarr = indexOf(filterAsyncRoutes, item)
          let namesres = getPaths(filterAsyncRoutes, indexarr)
          names = names.concat(namesres)
        }

        //根据已有权限的name数组集合获取route（父级子级）
        accessedRoleRoutes = filterArr(filterAsyncRoutes, names)
      }

      commit('SET_ROUTES', accessedRoleRoutes)
      resolve(accessedRoleRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
